<div class="traineeship__container">
  <section><app-hero [title]="'Offres de stages'" [icon]="'hero-traineeship'"></app-hero></section>
  <section class="currents-traineeship__container">
    <h2>Offres de stages disponibles</h2>

    <div class="currents-traineeship__list">
      @if (traineeships.isLoading()) {
        <p>Chargement...</p>
      } @else if (traineeships.hasValue()) {
        @for (traineeship of traineeships.value(); track traineeship) {
          <div class="currents-traineeship__item">
            <h3>{{ traineeship.title }}</h3>
            <div>
              <ul>
                <li><strong>Région :</strong> {{ traineeship.center.region }}</li>
              </ul>
              <ul>
                <li><strong>Centre :</strong> {{ traineeship.center.city }}</li>
              </ul>
              <ul>
                <li><strong>Période :</strong> {{ traineeship.time_period }}</li>
              </ul>
            </div>
            <div class="contact">{{ traineeship.contact }}</div>
          </div>
        }
      } @else if (!traineeships.hasValue()) {
        <div>Aucun résultats</div>
      }
    </div>

    <div class="buttons"><a routerLink="/" class="btn btn-primary-outline">Retour</a></div>
  </section>
</div>
